import type { DayOfWeek } from 'services/api';

export const getSlotKey = (
  day: DayOfWeek,
  startTime: string,
  endTime: string,
  educationClassId: number,
): string => {
  return `${day}-${startTime}-${endTime}-${educationClassId}`;
};
